// Shared inline-SVG paths + helpers for the stadium top-down view.
// Used by StadiumMap (Command Center) and HeatmapStadium (Crowd Intelligence).

export const STADIUM_VIEWBOX = "0 0 1000 720";

export const ZONE_PATHS = {
  // 8 stands in a ring around the pitch
  "stand-north":       "M500,40  L660,80  L660,180 L500,160 L340,180 L340,80  Z",
  "stand-north-east":  "M660,80  L820,200 L750,290 L640,210 Z",
  "stand-east":        "M820,200 L900,360 L780,360 L760,290 Z",
  "stand-south-east":  "M900,360 L820,520 L740,440 L780,360 Z",
  "stand-south":       "M820,520 L660,620 L660,520 L500,540 L340,520 L340,620 L180,520 Z",
  "stand-south-west":  "M180,520 L100,360 L220,360 L260,440 Z",
  "stand-west":        "M100,360 L180,200 L240,290 L220,360 Z",
  "stand-north-west":  "M180,200 L340,80 L360,210 L250,290 Z",

  // Gates
  "gate-a": "M120,30 L260,30 L260,70 L120,70 Z",
  "gate-b": "M740,30 L880,30 L880,70 L740,70 Z",
  "gate-c": "M120,630 L260,630 L260,670 L120,670 Z",
  "gate-d": "M740,630 L880,630 L880,670 L740,670 Z",

  "concourse-east": "M880,200 L960,200 L960,520 L880,520 Z",
  "vip-lounge":     "M420,650 L580,650 L580,690 L420,690 Z",
  "parking-north":  "M260,8 L740,8 L740,28 L260,28 Z",
  "parking-south":  "M260,690 L420,690 L420,710 L260,710 Z",
};

// Approximate centroid of an SVG path's coords (good enough for label placement).
export function pathCentroid(d) {
  const nums = d.match(/-?\d+(\.\d+)?/g)?.map(Number) || [];
  let sx = 0, sy = 0, n = 0;
  for (let i = 0; i + 1 < nums.length; i += 2) { sx += nums[i]; sy += nums[i + 1]; n++; }
  return { x: n ? sx / n : 0, y: n ? sy / n : 0 };
}

// Static flow vectors: which gate feeds which stand. Intensity is computed live.
export const FLOW_VECTORS = [
  { id: "f-ga-n",  from: "gate-a", to: "stand-north",      d: "M190,50  Q300,150 500,160" },
  { id: "f-gb-n",  from: "gate-b", to: "stand-north-east", d: "M810,50  Q780,180 760,290" },
  { id: "f-gc-s",  from: "gate-c", to: "stand-south",      d: "M190,650 Q300,580 500,560" },
  { id: "f-gd-v",  from: "gate-d", to: "vip-lounge",       d: "M810,650 Q700,650 500,670" },
  { id: "f-pn-a",  from: "parking-north", to: "gate-a",    d: "M330,28 Q260,40 190,50" },
  { id: "f-pn-b",  from: "parking-north", to: "gate-b",    d: "M670,28 Q740,40 810,50" },
  { id: "f-ps-c",  from: "parking-south", to: "gate-c",    d: "M340,700 Q260,680 190,670" },
  { id: "f-ce-e",  from: "concourse-east", to: "stand-east", d: "M880,360 Q830,360 780,360" },
];
